export const isMobile = () => {
  return window.matchMedia("(max-width: 800px)").matches;
};
